import { FC, useCallback } from "react";
import { CustomCellRendererProps } from "ag-grid-react";
import { useDispatch } from "react-redux";
import { Stack, Tooltip } from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";
import {
  setReportsData,
  toggleReportsOpenDrawer,
} from "@/store/reports/reportsSlice";
import { ReportsTableData } from "@/store/reports/utils/types/types";
import { formatNotificationsFromSlackToHtml } from "@/components/utils/helpers/slack-formatters/formatNotificationsFromSlackToHtml";

export const ReportsNameCell: FC<CustomCellRendererProps<ReportsTableData>> = ({
  data,
}) => {
  const dispatch = useDispatch();
  const handleClick = useCallback(() => {
    if (!data) {
      return;
    }

    dispatch(
      setReportsData({
        ...data,
        notifications: formatNotificationsFromSlackToHtml(data.notifications),
      }),
    );
    dispatch(toggleReportsOpenDrawer());
  }, [dispatch, data]);

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      {!data?.sourceName && (
        <Tooltip arrow placement="top" title={tooltipTitle}>
          <WarningAmberRoundedIcon color="warning" />
        </Tooltip>
      )}

      <TypographyWithTooltip
        fontWeight="regular"
        color="primary"
        onClick={handleClick}
        sx={{ textDecoration: "underline", cursor: "pointer" }}
        variant="body2"
        title={data?.name}
      />
    </Stack>
  );
};

const tooltipTitle =
  "The source for this subscription was deleted, and all notifications are currently paused. To resume receiving notifications, please edit the subscription and select a new source.";
